import { IRequesterInfo } from "../../../../../base/models"
import { ClientProxy } from "../../../../../base/proxy/clientProxy"
import { IDealer } from "../models/model"


export class GetDealersApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/dealer/dealerListAll',
      requesterInfo,
    })
  }

  public async getDealers(req: any): Promise<IDealer[]> {
    return await this.postAsync<IDealer[]>(req)
  }
}